import axios from 'axios';

import { auth } from '../services/firebase';


const EXTENDED_URL = process.env.REACT_APP_API_EXTENDED_NEURO_URL; //'http://localhost:4000/api';
console.log('---> axiosConfig EXTENDED_URL:', EXTENDED_URL);                           
export const axiosInstance = axios.create({
  EXTENDED_URL,
  withCredentials: true,
});

export const authAPI = {
  login: (credentials) => axiosInstance.post('/users/login', credentials),
  register: (userData) => axiosInstance.post('/users/register', userData),
  logout: () => axiosInstance.post('/users/logout'),
  getCurrentUser: () => axiosInstance.get('/users/me'),
};

export const dataAPI = {
  getData: () => axiosInstance.get('/api/data'),
  addData: (data) => axiosInstance.post('/api/data', data),
  updateData: (id, data) => axiosInstance.put(`/api/data/${id}`, data),
  deleteData: (id) => axiosInstance.delete(`/api/data/${id}`),
};

// Add a request interceptor
axiosInstance.interceptors.request.use(async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });